import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, MapPin, Calendar } from "lucide-react";
import { experience } from "../data/mock";

const ExperienceTimeline = () => {
  return (
    <section
      id="experience"
      style={{
        padding: "100px 7.6923%",
        background: "var(--bg-primary)",
        borderTop: "1px solid var(--border-subtle)",
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* Section Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          style={{
            textAlign: "center",
            marginBottom: "80px",
          }}
        >
          <h2
            style={{
              fontSize: "48px",
              fontWeight: 600,
              color: "var(--text-primary)",
              marginBottom: "16px",
            }}
          >
            Deployment Pipeline
          </h2>
          <p style={{ fontSize: "18px", color: "var(--text-muted)" }}>
            Career journey through successful builds
          </p>
        </motion.div>

        {/* Timeline */}
        <div
          style={{
            position: "relative",
          }}
        >
          {/* Timeline Line */}
          <div
            style={{
              position: "absolute",
              left: "20px",
              top: "0",
              bottom: "0",
              width: "2px",
              background: "linear-gradient(to bottom, var(--brand-primary), rgba(0, 255, 209, 0.3), transparent)",
            }}
          />

          {/* Timeline Items */}
          {experience.map((job, index) => (
            <motion.div
              key={job.id}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.15 }}
              style={{
                marginBottom: "60px",
                paddingLeft: "60px",
                position: "relative",
              }}
            >
              {/* Build Status Badge */}
              <motion.div
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 + 0.2 }}
                style={{
                  position: "absolute",
                  left: "0",
                  top: "0",
                  width: "40px",
                  height: "40px",
                  background: "var(--bg-primary)",
                  border: "2px solid var(--brand-primary)",
                  borderRadius: "0px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 2,
                  cursor: "pointer",
                }}
              >
                <CheckCircle2 size={24} color="var(--brand-primary)" />
              </motion.div>

              {/* Job Card */}
              <motion.div
                whileHover={{ x: 15, scale: 1.02 }}
                className="glass hover-lift"
                style={{
                  padding: "30px",
                  borderRadius: "0px",
                  border: "1px solid var(--border-medium)",
                  transition: "all 0.3s ease",
                }}
              >
                {/* Header */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "20px",
                    flexWrap: "wrap",
                    gap: "12px",
                  }}
                >
                  <div>
                    <h3
                      style={{
                        fontSize: "24px",
                        fontWeight: 600,
                        color: "var(--text-primary)",
                        marginBottom: "8px",
                      }}
                    >
                      {job.role}
                    </h3>
                    <p
                      style={{
                        fontSize: "18px",
                        color: "var(--brand-primary)",
                        fontWeight: 500,
                        marginBottom: "12px",
                      }}
                    >
                      {job.company}
                    </p>
                    <div
                      style={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          fontSize: "14px",
                          color: "var(--text-muted)",
                        }}
                      >
                        <Calendar size={16} />
                        {job.period}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          fontSize: "14px",
                          color: "var(--text-muted)",
                        }}
                      >
                        <MapPin size={16} />
                        {job.location}
                      </div>
                    </div>
                  </div>

                  {/* Build Number */}
                  <div
                    style={{
                      background: "rgba(0, 255, 209, 0.1)",
                      padding: "8px 16px",
                      borderRadius: "0px",
                      border: "1px solid var(--brand-primary)",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        color: "var(--brand-primary)",
                        fontWeight: 600,
                        fontFamily: "monospace",
                      }}
                    >
                      {job.buildNumber}
                    </span>
                  </div>
                </div>

                {/* Achievements */}
                <ul
                  style={{
                    listStyle: "none",
                    padding: 0,
                    margin: 0,
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {job.achievements.map((achievement, i) => (
                    <li
                      key={i}
                      style={{
                        display: "flex",
                        gap: "12px",
                        fontSize: "16px",
                        color: "var(--text-secondary)",
                        lineHeight: "1.6",
                      }}
                    >
                      <CheckCircle2 size={20} color="var(--success)" style={{ flexShrink: 0, marginTop: "2px" }} />
                      <span>{achievement}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceTimeline;
